/**
 * /app/$tenantSlug/leave/approvals — alias of the unified inbox's Leave
 * tab (2026-10 QA #16).
 *
 * The page used to be a URL-only orphan (no nav entry — the Time & Leave
 * strip's "Approvals" item already goes to the unified /approvals inbox)
 * duplicating the /approvals Leave tab. It now redirects there, so
 * bookmarks and any stored link to /leave/approvals land on the real
 * queue.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/leave/approvals",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/app/$tenantSlug/approvals",
      params: { tenantSlug: params.tenantSlug },
      search: { tab: "leave" },
      replace: true,
    });
  },
});
